import { render } from "./Sphere.vue?vue&type=template&id=4ce0f9a6"
import script from "./Sphere.vue?vue&type=script&lang=js"
export * from "./Sphere.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/polissonos-web/polissonos-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__